import { Routes, Route } from "react-router-dom"
import Home from "./pages/Home"
import Services from "./pages/Services"
import Projects from "./pages/Projects"
import About from "./pages/About"
import Contact from "./pages/Contact"
import Admin from "./pages/Admin"
import AdminLogin from "./pages/AdminLogin"
import AdminUsers from "./pages/AdminUsers"
import AdminServices from "./pages/AdminServices"
import AdminProjects from "./pages/AdminProjects"
import AdminStats from "./pages/AdminStats"
import WhatsAppButton from "./components/WhatsAppButton"
import AdminProtectedRoute from "./components/AdminProtectedRoute"

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route path="/hizmetler" element={<Services />} />
        <Route path="/projeler" element={<Projects />} />
        <Route path="/hakkimizda" element={<About />} />
        <Route path="/iletisim" element={<Contact />} />
        
        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={
          <AdminProtectedRoute>
            <Admin />
          </AdminProtectedRoute>
        } />
        <Route path="/admin/users" element={
          <AdminProtectedRoute>
            <AdminUsers />
          </AdminProtectedRoute>
        } />
        <Route path="/admin/services" element={
          <AdminProtectedRoute>
            <AdminServices />
          </AdminProtectedRoute>
        } />
        <Route path="/admin/projects" element={
          <AdminProtectedRoute>
            <AdminProjects />
          </AdminProtectedRoute>
        } />
        <Route path="/admin/stats" element={
          <AdminProtectedRoute>
            <AdminStats />
          </AdminProtectedRoute>
        } />
      </Routes>
      
      {/* WhatsApp Button - Her sayfada görünür */}
      <WhatsAppButton />
    </div>
  )
}

export default App
